module.exports = __webpack_public_path__ + "static/media/banner.2929b49e.jpg";